import TablaConciliacion from "../../../TablaConciliacion";

function TablaFindeter() {
  return <TablaConciliacion nombreUseCase="FINDETER" titulo="FINDETER" />;
}

export default TablaFindeter;
